import React from "react";
import { Helmet } from "react-helmet";
import "./support.css";

export const seo = {
  title: "Privacy Policy | Aooz Status",
  description:
    "Learn how Aooz Status protects your privacy and handles information when you use status.aooz.in to browse and share status messages.",
  keywords:
    "aooz status privacy policy, status aooz privacy, aooz status data policy, privacy status website",
  url: "https://status.aooz.in/privacy-policy",
  image: "https://status.aooz.in/logo.png",
};

export default function Privacy_policy() {
  return (
    <div>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={seo.image} />
        <meta property="og:url" content={seo.url} />
      </Helmet>

      <div className="container_roots">
        <div className="container_size_info">

          <h2 className="bold text-hero-sub">Privacy Policy – Aooz Status</h2>

          <div className="post-container text-pre-30">

            <div className="post-div">

              <div className="trxt-h2">

                At <b>Aooz Status</b> (status.aooz.in), we respect your privacy.
                This Privacy Policy explains how we collect, use, and protect
                information when you visit our website.

              </div>

              <div className="text-hero-sub mt-3">1. Information We Collect</div>

              <div className="trxt-h2">

                Aooz Status does not require users to create an account to
                browse status messages.

                <br /><br />

                However, some information may be collected automatically such as:

                <br />
                • IP address <br />
                • Browser type <br />
                • Device information <br />
                • Pages visited on our website

                <br /><br />

                This information helps us improve website performance
                and user experience.

              </div>


              <div className="text-hero-sub mt-3">2. Cookies</div>

              <div className="trxt-h2">

                Our website may use cookies to enhance your browsing
                experience and analyze traffic.

                <br /><br />

                Cookies help us understand how users interact with
                our platform.

                <br /><br />

                You can disable cookies anytime through your browser settings.

              </div>


              <div className="text-hero-sub mt-3">3. Third-Party Services</div>

              <div className="trxt-h2">

                We may use third-party tools such as analytics or
                advertising networks.

                <br /><br />

                These services may collect information according to
                their own privacy policies.

                <br /><br />

                Examples may include:

                <br />
                • Google Analytics <br />
                • Advertising partners

              </div>


              <div className="text-hero-sub mt-3">4. Content Usage</div>

              <div className="trxt-h2">

                Status messages and quotes available on Aooz Status
                are provided for informational and entertainment purposes.

                <br /><br />

                Users may copy and share the content on social media
                platforms for personal use.

              </div>


              <div className="text-hero-sub mt-3">5. External Links</div>

              <div className="trxt-h2">

                Our website may contain links to other websites.
                We are not responsible for the privacy practices
                of external websites.

              </div>


              <div className="text-hero-sub mt-3">6. Children's Information</div>

              <div className="trxt-h2">

                Aooz Status does not knowingly collect personal
                information from children under 13 years of age.

                <br /><br />

                If you believe that a child has provided personal
                information on our website, please contact us and
                we will remove the information promptly.

              </div>


              <div className="text-hero-sub mt-3">7. Updates to This Policy</div>

              <div className="trxt-h2">

                We may update this Privacy Policy from time to time.
                Any updates will be posted on this page.

              </div>


              <div className="text-hero-sub mt-3">8. Contact Us</div>

              <div className="trxt-h2">

                If you have questions about this Privacy Policy,
                please contact us through our support page.

                <br /><br />

                Email: support@aooz.in

              </div>

              <div className="trxt-h2 mt-3">
                <b>Last Updated:</b> 2026
              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
}